<template>
  <div>
    <div id="EmployeesAccount">
      <!--      头部文字-->
      <div class="EmployeesAccountTitle">お気に入り商品</div>
      <!--      状态切换-->
      <div class="flex orderScreenContainer">
        <div class="orderScreenLeft flexAndCenter">
          <div v-for="(item,index) in addressSwitchover" :key="index"
               :class="switchoverIndex===index?'activeSwitchover label flexAndCenter':'label flexAndCenter'"
               @click="switchoverIndex=index;list.goods_status=item.value;$forceUpdate;getData()">
            {{ item.label }}（<span>{{ item.count }}</span>）
            <div v-if="index===0" class="border">|</div>
          </div>
        </div>
        <!--      关键词搜索-->
        <div class="orderScreenBtnListContainer flexAndCenter">
          <el-input v-model="list.keywords" placeholder="キーワードをご記入ください"/>
          <div @click="getData()">検索</div>
        </div>
      </div>
      <!--      标签名称-->
      <div :style="tagList.length>0?'paddingBottom:8px':'paddingBottom:20px'" class="flex tagMessageContainer">
        <div class="tagMessageLeftContainer flex">
          <div class="fontSize14 color333 tagNameText">タグ：</div>
          <div class="tagListContainer">
            <div v-for="(item,index) in tagList" :key="index"
                 :style="list.tag_ids.lastIndexOf(item.id)!==-1?'border: 1px solid #B4272B;color:#B4272B':''"
                 class="tagContainer"
                 @click="updateSearch(item)">
              <span>{{ item.tag_name }}</span>
              <img src="@/assets/user/commodity/redEditIcon.png" style="margin-left: 8px"
                   @click.stop="getEditTagInfo(item)"/>
              <div class="deleteTagContainer" @click.stop="deleteIcon(item)">x</div>
            </div>
          </div>
        </div>
        <!--      标签名搜索-->
        <div class="tagMessageRightContainer flexAndCenter">
          <div class="label">新規追加：</div>
          <el-input v-model="tagValue" placeholder="タグ名をご記入ください"></el-input>
          <div class="addTagBtn" @click="addTag">追加</div>
        </div>
      </div>
      <!--      操作栏-->
      <div class="goodsCollectListOperationContainer flexAndCenter">
        <div class="checkboxContainer flexAndCenter">
          <input v-model="checked" type="checkbox" @change="updateGoodsChecked"/>
          <div>すべて選択</div>
          <img class="sortIcon" src="@/assets/user/commodity/sort.png" @click="updateGoodsSort">
        </div>
        <div class="btnList flexAndCenter">
          <div @click="delGoods('','all')">削除</div>
        </div>
      </div>
      <!--      收藏商品列表-->
      <div class="goodsCollectListContainer">
        <div v-for="(item,index) in goodsList"
             :key="index" :class="item.goods_status==1?'newGoodsCollectContainer':'goodsCollectContainer'"
             :style="item.checked===true?'border: 1px solid #B4272B;':''">
          <div class="imgContainer"
               @mouseenter="goodsMouseenter(index)" @mouseleave="goodsMouseleave(index)">
            <!--      背景图片-->
            <router-link
                :to="
                  item.type == 'RAKUMART'
                    ? '/details?id=' + item.iid
                    : `/details1688?iid=${item.iid}&type=${item.type}${item.mi_id ? '&mi_id=' + item.mi_id : ''}`
                "
                target="_blank"
            >
              <img :src="item.pic" class="goodsImg"/>
            </router-link>
            <div class="goodsCollectOperationContainer flex">
              <!--      单选-->
              <input v-model="item.checked" class="cursorPointer" type="checkbox" @change.stop="isAllSelectGoods"/>
              <div v-show="item.imgShowIcon===true">
                <!--      标签操作-->
                <el-popover trigger="hover">
                  <div class="tagSelectContainer" @mouseleave="goodsTagsMouseleave(item)">
                    <div :style="tagList.length==0?'margin-bottom:0':''" class="tagSelectHeader">タグリスト：
                    </div>
                    <div class="tagItemListContainer">
                      <div v-for="(tagItem,tagIndex) in tagList" :key="tagIndex" class="tagItem flexAndCenter"
                           @click="tagItem.checked=!tagItem.checked">
                        <input v-model="tagItem.checked" style="margin-left: 0" type="checkbox"/>
                        <div>{{ tagItem.tag_name }}</div>
                      </div>
                    </div>
                  </div>
                  <img slot="reference" src="@/assets/user/commodity/editTagIcon.png"
                       style="margin-right: 8px;width:20px" @mouseenter="goodsTagsMouseenter(item)">
                </el-popover>
                <!--      单个收藏商品删除-->
                <img src="@/assets/user/commodity/deleteGoods.png" style="width: 22px"
                     @click.stop="delGoods(item,'noAll')">
              </div>
            </div>
            <!--      图片搜索-->
            <div v-show="item.imgShowIcon===true" class="lookSimilarities" @click="imgSearchGoods(item.pic)">
              <div class="flexAndCenter" @click="imgSearchGoods(item.pic)">
                <i class="el-icon-search"></i>
                <div>類似品を検索</div>
              </div>
            </div>
            <div v-if="item.goods_status==1" class="soldOutIcon">販売終了</div>
          </div>
          <div class="goodsCompany" style="height:16px">
            {{ item.company }}
          </div>
          <div class="goodsTitle u-line-2">{{ item.title }}</div>
          <div class="goodsCollectFooterContainer flexAndCenter">
            <div>¥{{ item.price }}</div>
            <div v-if="item.type!=1688">{{ item.type }}</div>
            <img v-else src="@/assets/user/commodity/1688logo.svg" style="width: 30px">
          </div>
          <div style="margin:10px 10px 0">
            <el-input v-model="item.remark" placeholder="备注" size="mini" @blur="updateGoodsRemark(item)"/>
          </div>
        </div>
      </div>
      <el-dialog
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :visible.sync="withdrawDepositErrorDialogVisible"
          center
          width="400px">
        <div class="dialogHeader flexAndCenter">
          <img src="@/assets/user/commodity/tips.png">
          <div>注意</div>
        </div>
        <div class="dialogFooter">
          <div>{{ hintDialogVisibleText }}</div>
        </div>
        <span slot="footer" class="delete-dialog-footer">
         <el-button type="text" @click="withdrawDepositErrorDialogVisible = false">キャンセル</el-button>
         <el-button type="primary" @click="confirmDelete">確定</el-button>
        </span>
      </el-dialog>
      <el-dialog
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :visible.sync="updateTagNameDialogVisible"
          :show-close="false"
          width="350px">
        <div class="flexAndCenter updateTagNameBox">
          <div class="label">新規修改：</div>
          <el-input style="width: 220px" v-model="tagInfo.tag_name" />
        </div>
        <span slot="footer" class="delete-dialog-footer">
         <el-button type="primary" @click="updateTagName">確定</el-button>
        </span>
      </el-dialog>
      <div class="paginationContainer">
        <el-pagination
            :current-page="list.page"
            :page-size="list.pageSize"
            :page-sizes="[15, 30, 45, 60]"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {
  newFavoriteList,
  favoriteTagDelete,
  getGoodsTableNum,
  favoriteGoodsToTags,
  favoriteGoodsUpdateRemark,
  favoriteTagAdd,
  favoriteTagNameEdit,
  newFavoriteDelete,
  favoriteTagList
} from "@/api/API/commodity";
import {taobaoPicSearchLis} from "@/api/API/home";
import {deepClone} from '@/utlis/utlis'
import {mapMutations} from "vuex";

export default {
  data() {
    return {
      list: {
        goods_status: 0,
        order_by: 'desc',
        tag_ids: '',
        page: 1,
        pageSize: 15,
        keywords: '',
      },
      token: localStorage.getItem("token"),
      deleteGoodsType: 'noAll',
      hintDialogVisibleText: 'こちらの商品削除してよろしいですか。',
      withdrawDepositErrorDialogVisible: false,
      updateTagNameDialogVisible: false,
      tagInfo: {},
      goodsInfo: {},
      checked: false,
      tagList: [],
      tagValue: '',
      addressSwitchover: [{
        label: `全商品`,
        count: 0,
        value: 0
      }, {
        label: `URL無効`,
        count: 0,
        value: 1
      }],
      switchoverIndex: 0,
      total: 0,
      goodsList: [],
    };
  },
  computed: {},
  mounted() {
    this.getData();
    this.getTag();
    this.getGoodsTableNum();
  },
  methods: {
    ...mapMutations([
      "imgSearch",
      "isLoading",
    ]),
    // 获取数据
    getData() {
      let datas = {
        token: localStorage.getItem("token"),
        goods_status: this.list.goods_status,
        order_by: this.list.order_by,
        tag_ids: this.list.tag_ids,
        page: this.list.page,
        pageSize: this.list.pageSize,
        keywords: this.list.keywords,
      }
      newFavoriteList(datas).then((res) => {
        if (res.code !== 0) return this.$message.error(res.msg);
        res.data.data.forEach((item) => {
          item.checked = false;
          item.imgShowIcon = false;
          this.$forceUpdate();
        })
        this.goodsList = res.data.data;
        this.total = res.data.total;
      });
    },
    getGoodsTableNum() {
      getGoodsTableNum({token: localStorage.getItem("token")}).then((res) => {
        res.data.forEach((item) => {
          if (item.name === "上架中") {
            this.addressSwitchover[0].count = item.count;
          } else if (item.name === "已下架") {
            this.addressSwitchover[1].count = item.count;
          }
        })
      })
    },
    //设置每页多少条
    handleSizeChange(val) {
      this.list.pageSize = val;
      this.getData()
    },
    //设置当前多少页
    handleCurrentChange(val) {
      this.list.page = val;
      this.getData()
    },
    updateGoodsRemark(item) {
      if (item.remark != '' && item.remark != null) {
        favoriteGoodsUpdateRemark({
          id: item.id,
          remark: item.remark,
          token: this.token
        }).then((res) => {
          if (res.code != 0) return this.$message.error(this.$fanyi(res.msg));
        }).catch(() => {
        });
      }
    },
    //更新标签的名称
    updateTagName() {
      if (this.tagInfo.tag_name !== '') {
        favoriteTagNameEdit({
          tag_id: this.tagInfo.id,
          tag_name: this.tagInfo.tag_name,
          token: localStorage.getItem("token"),
        }).then((res) => {
          if (res.code != 0) return this.$message.error(res.msg);
          this.$message.success(res.msg);
          this.updateTagNameDialogVisible=false;
          this.list.tag_ids = '';
          this.list.pageSize = 15;
          this.list.page = 1;
          this.getData();
          this.getGoodsTableNum();
          this.getTag();
        }).catch(() => {
        });
      }
    },
    //获取要编辑的tag信息
    getEditTagInfo(val) {
      this.tagInfo = deepClone(val);
      this.updateTagNameDialogVisible=true;
    },
    //获取要筛选的标签
    updateSearch(val) {
      if (this.list.tag_ids === '') {
        this.list.tag_ids = val.id
      } else if (this.list.tag_ids !== '' && this.list.tag_ids.indexOf(val.id) === -1) {
        this.list.tag_ids += ',' + val.id
      } else if (this.list.tag_ids !== '' && this.list.tag_ids.indexOf(val.id) !== -1) {
        let index = this.list.tag_ids.indexOf(val.id);
        let target = '';
        if (index === 0) {
          target = val.id;
        } else {
          target = ',' + val.id;
        }
        this.list.tag_ids = this.list.tag_ids.replace(target, "");
      }
      this.getData();
    },
    //获取tag标签列表
    getTag() {
      favoriteTagList({
        type: 1,
        token: localStorage.getItem("token")
      }).then((res) => {
        res.data.forEach((item) => {
          item.checked = false;
          item.id = item.id + ''
        })
        this.tagList = res.data;
      })
    },
    //更新列表排序状态
    updateGoodsSort() {
      this.list.order_by === 'asc' ? this.list.order_by = 'desc' : this.list.order_by = 'asc';
      this.getData();
      this.getTag();
      this.getGoodsTableNum();
    },
    //添加tag标签
    addTag() {
      if (this.tagValue !== '') {
        favoriteTagAdd({
          type: 1,
          token: this.token,
          tag_name: this.tagValue
        }).then((res) => {
          if (res.code != 0) return this.$message.error(res.msg);
          this.$message.success(res.msg);
          this.tagValue = '';
          this.getTag();
        })
      }
    },
    //商品详细鼠标移入
    goodsMouseenter(index) {
      this.goodsList[index].imgShowIcon = true;
      this.$forceUpdate();
    },
    //商品详细鼠标移出
    goodsMouseleave(index) {
      this.goodsList[index].imgShowIcon = false;
      this.$forceUpdate();
    },
    handleClose(done) {
      this.$confirm(`${this.$fanyi("确认关闭")}？`)
          .then(_ => {
            done();
          })
          .catch(_ => {
          });
    },
    //查看tag鼠标移入
    goodsTagsMouseenter(item) {
      this.tagList.forEach((tagItem) => {
        tagItem.checked = false;
      })
      let tagIds = [];
      if (item.tag_ids !== '') {
        tagIds = item.tag_ids.split(',');
        this.tagList.forEach((tagItem) => {
          tagIds.forEach((tagIdsItem) => {
            if (tagItem.id == tagIdsItem) {
              tagItem.checked = true
            }
          })
        })
      }
    },
    //图片搜索
    imgSearchGoods(img) {
      this.isLoading(true);
      taobaoPicSearchLis({picurl: img}).then((res) => {
        this.isLoading(false);
        this.imgSearch(res.list);
        this.$router.push({name: "list1688", query: {img: "list"}});
      });
    },
    //查看tag鼠标移出
    goodsTagsMouseleave(item) {
      let goodsIds='';
      this.goodsList.forEach((tagItem) => {
        if (tagItem.checked === true) {
          goodsIds += tagItem.id + ','
        }
      })
      goodsIds = goodsIds.substr(0, goodsIds.length - 1);
      let tagIds = '';
      this.tagList.forEach((tagItem) => {
        if (tagItem.checked === true) {
          tagIds += tagItem.id + ','
        }
      })
      tagIds = tagIds.substr(0, tagIds.length - 1);
      favoriteGoodsToTags({
        id: goodsIds,
        tag_ids: tagIds,
        token: this.token,
      }).then((res) => {
        if (res.code != 0) return this.$message.error(res.msg);
        this.getData();
      })
    },
    //确认删除以及删除后的处理
    confirmDelete() {
      if (this.hintDialogVisibleText === 'こちらの商品削除してよろしいですか。') {
        let arr = [];
        //是否是全部删除
        if (this.deleteGoodsType === 'noAll') {
          arr.push({type: this.goodsInfo.type, iid: this.goodsInfo.iid})
          newFavoriteDelete({
            delete: arr,
            token:this.token
          }).then((res) => {
            if (res.code != 0) return this.$message.error(res.msg);
            this.withdrawDepositErrorDialogVisible=false;
            this.$message.success(res.msg);
            this.getData();
            this.getGoodsTableNum();
          })
        } else {
          this.goodsList.forEach((goodsItem) => {
            if (goodsItem.checked === true) {
              arr.push({type: goodsItem.type, iid: goodsItem.iid})
            }
          })
          if (arr.length > 0) {
            newFavoriteDelete({
              delete: arr,
              token:this.token
            }).then((res) => {
              if (res.code != 0) return this.$message.error(res.msg);
              this.withdrawDepositErrorDialogVisible=false;
              this.$message.success(res.msg);
              this.getData();
              this.getGoodsTableNum();
            })
          }
        }
      } else {
        this.withdrawDepositErrorDialogVisible = false;
      }
    },
    //删除收藏商品
    delGoods(item, type) {
      if (type === 'noAll') {
        this.goodsInfo = item;
        this.deleteGoodsType = type;
        this.withdrawDepositErrorDialogVisible = true;
        this.hintDialogVisibleText = 'こちらの商品削除してよろしいですか。';
      }
      let arr = [];
      this.goodsList.forEach((goodsItem) => {
        if (goodsItem.checked === true) {
          arr.push(goodsItem);
        }
      })
      if (arr.length > 0) {
        this.deleteGoodsType = type;
        this.withdrawDepositErrorDialogVisible = true;
        this.hintDialogVisibleText = 'こちらの商品削除してよろしいですか。';
      }
    },
    //删除icon
    deleteIcon(item) {
      this.$confirm(
          '削除の確認',
          '注意',
          {
            confirmButtonText: '確定', //确定
            cancelButtonText: 'キャンセル', //取消
            type: "warning",
            center: true,
            dangerouslyUseHTMLString: true,
          }
      ).then(() => {
        favoriteTagDelete({
          tag_id: item.id,
          token: this.token
        }).then((res) => {
          if (res.code != 0) return this.$message.error(res.msg);
          this.$message.success(res.msg);
          this.list.tag_ids = '';
          this.getTag();
          this.getData()
        })
      }).catch(() => {

      });
    },
    //更新全部商品选中状态
    updateGoodsChecked() {
      this.goodsList.forEach((item) => {
        item.checked = this.checked;
      })
    },
    //是否全部选中
    isAllSelectGoods() {
      let count = 0;
      this.goodsList.forEach((item, index) => {
        if (item.checked === true) {
          count++
        }
        if (index === this.goodsList.length - 1) {
          this.checked = count === this.goodsList.length;
        }
      })
    },
  },
};
</script>
<style lang='scss' scoped>
@import "@/css/mixin.scss";

/deep/ input[type="checkbox"]:checked {
  background: #4A91E9;
}

/deep/ .el-dialog__header, /deep/ .el-dialog__body {
  padding: 0;
}
.delete-dialog-footer{
  .el-button--text{
    color: #222222;
    font-size: 14px;
    font-weight: 500;
  }
  .el-button--primary{
    width: 68px;
    height: 30px;
    border-radius: 5px;
    line-height: 30px;
    padding: 0;
  }
}

/deep/ .el-dialog {
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/deep/ .el-dialog__headerbtn {
  top: 22px;

  .el-icon-close {
    color: #222;
    font-weight: bold;
  }
}

.dialogHeader {
  padding-left: 30px;
  height: 60px;
  border-bottom: 1px solid #E9E9E9;

  img {
    width: 18px;
    height: 18px;
    margin-right: 6px;
  }

  div {
    color: #222222;
    font-size: 14px;
    font-weight: 500;
  }
}

.dialogCenter {
  .newTitle {
    margin: 20px 0 30px 20px;
    font-size: 20px;
    color: #B4272B;
    font-weight: bold;
  }

  .confirmMessageContainer {
    width: 280px;
    margin: 0 auto 30px;

    .label {
      text-align: right;
      width: 100px;
    }

    .balance {
      div:first-child {
        color: #B4272B;
        font-weight: bold;
        font-size: 16px;
        margin-right: 10px;
      }
    }

    .overflowText {
      //width: 135px;
      max-width: 135px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}

.dialogFooter {
  padding: 30px 0;
  div {
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    color: #222;
  }
}

.tableDataNullContainer {
  height: 100px;
  line-height: 100px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}

.tagSelectContainer {

  .tagSelectHeader {
    color: #333333;
    font-size: 14px;
    margin-bottom: 16px;
  }

  .tagItemListContainer {
    max-height: 300px;
    overflow-y: scroll;

    .tagItem {
      color: #999999;
      font-size: 14px;
      margin-bottom: 11px;
      cursor: pointer;

      div {
        margin-left: 4px;
      }
    }
  }
}

#EmployeesAccount {
  background: #ffffff;
  border-radius: 10px;

  .EmployeesAccountTitle {
    height: 40px;
    padding: 0 20px;
    background: #EEEEEE;
    color: #222222;
    line-height: 40px;
    font-size: 20px;
  }

  .orderScreenContainer {
    padding: 24px 20px;
    border-bottom: 1px solid #E9E9E9;
    justify-content: space-between;

    .orderScreenLeft {
      .label {
        font-size: 16px;
        font-weight: bold;
        color: #222222;
        cursor: pointer;

        span {
          color: #B7040B
        }

        .border {
          width: 24px;
          color: #222222;
          text-align: center;
        }
      }

      .activeSwitchover {
        color: #B7040B;
      }
    }

    .orderScreenBtnListContainer {
      /deep/ .el-input__inner {
        width: 220px;
        height: 32px;
        background: #FFFFFF;
        border: 1px solid #DFDFDF;
        border-radius: 5px;
      }

      div:last-child {
        background: #F3C622;
        height: 32px;
        color: #222222;
        min-width: 80px;
        cursor: pointer;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        line-height: 32px;
        margin-left: 10px;
        border-radius: 5px;
      }
    }
  }

  .tagMessageContainer {
    margin: 20px 20px 0;
    border-bottom: 1px solid #E9E9E9;
    justify-content: space-between;

    .tagNameText {
      min-width: 86px;
      width: 86px;
      margin-top: 4px;
    }

    .tagListContainer {
      display: flex;
      flex-wrap: wrap;
      width: 700px;

      .tagContainer {
        position: relative;
        padding: 7px 9px;
        color: #333;
        font-size: 12px;
        border-radius: 6px;
        background: #F0F0F0;
        margin-right: 22px;
        margin-bottom: 12px;
        cursor: pointer;
      }

      .deleteTagContainer {
        width: 16px;
        height: 16px;
        background: #B4272B;
        border-radius: 50%;
        color: #fff;
        text-align: center;
        font-size: 12px;
        line-height: 15px;
        cursor: pointer;
        position: absolute;
        left: -5px;
        top: -5px;
      }

      img {
        position: absolute;
        right: -5px;
        top: -5px;
        width: 14px;
        height: 16px;
      }
    }

    .tagMessageRightContainer {
      .label {
        font-size: 14px;
        color: #222222;
        min-width: 70px;
      }

      max-height: 32px;

      /deep/ .el-input__inner {
        width: 220px;
        height: 32px;
        background: #FFFFFF;
        border: 1px solid #E9E9E9;
        border-radius: 5px;
      }

      .addTagBtn {
        color: #222222;
        background: #F3C622;
        height: 32px;
        line-height: 32px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        min-width: 80px;
        margin-left: 10px;
        border-radius: 5px;
      }
    }
  }

  .goodsCollectListOperationContainer {
    justify-content: space-between;
    padding: 20px 0;
    margin: 0 20px;
    border-bottom: 1px solid #E9E9E9;

    .checkboxContainer {
      input {
        width: 24px;
        height: 24px;
        border-radius: 4px;
        border: 1px solid #E9E9E9;
        cursor: pointer;
      }

      div {
        color: #999999;
        font-size: 14px;
        margin: 0 10px;
      }

      .sortIcon {
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }

    .btnList {
      div {
        width: 80px;
        height: 32px;
        border-radius: 5px;
        background: #B4272B;
        line-height: 32px;
        cursor: pointer;
        text-align: center;
        font-size: 14px;
        color: #fff;
      }
    }
  }

  .goodsCollectListContainer {
    margin: 0 20px;
    padding-top: 20px;
    display: flex;
    flex-wrap: wrap;

    .goodsCollectContainer, .newGoodsCollectContainer {
      width: 214.6px;
      height: 375.6px;
      background: #FFFFFF;
      border: 1px solid #E9E9E9;
      border-radius: 5px;
      overflow: hidden;
      margin-right: 20px;
      margin-bottom: 20px;
      position: relative;

      .imgContainer {
        width: 217.6px;
        height: 217.6px;
        cursor: pointer;

        .goodsImg {
          width: 217.6px;
          height: 217.6px;
        }

        .goodsImg:hover {
          opacity: 0.3;
        }

        .soldOutIcon {
          position: absolute;
          top: 32%;
          left: 28%;
          width: 90px;
          height: 30px;
          background: #000000;
          border-radius: 15px;
          opacity: 0.5;
          font-size: 14px;
          color: #FFFFFF;
          text-align: center;
          line-height: 30px;
        }
      }

      input[type="checkbox"]:checked {
        background: #B4272B;
        border: 1px solid #B4272B;
      }

      .goodsCollectOperationContainer {
        position: absolute;
        top: 10px;
        left: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 195.72px;
        opacity: 1;

        .el-icon-folder, .el-icon-delete-solid {
          cursor: pointer;
        }

        input {
          width: 24px;
          height: 24px;
          border-radius: 4px;
          border: 1px solid #E9E9E9;
        }
      }

      .lookSimilarities {
        position: absolute;
        width: 217.6px;
        height: 30px;
        background: #F3C622;
        bottom: 158px;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        opacity: 1;
        color: #222222;

        .el-icon-search {
          color: #222222;
          margin-right: 6.97px;
        }

        .flexAndCenter {
          div {
            color: #222222;
            font-size: 13px;
            font-weight: 500;
          }
        }
      }

      .goodsTitle {
        color: #222222;
        font-size: 14px;
        height: 40px;
        margin: 10px;
      }

      .goodsCompany {
        font-size: 14px;
        color: #999999;
        padding: 10px 0 0 10px;
      }

      .goodsCollectFooterContainer {
        padding: 0 10px;
        justify-content: space-between;

        div:first-child {
          color: #B7040B;
          font-weight: bold;
          font-size: 18px;
        }

        div:last-child {
          color: #FF0000;
          font-weight: bold;
        }
      }
    }

    .newGoodsCollectContainer {
      .imgContainer {
        background: #000000;
        opacity: 0.6;
      }

      .goodsCollectFooterContainer div, .goodsTitle {
        color: #999999 !important;
      }
    }

    .goodsCollectContainer:nth-child(5n), .newGoodsCollectContainer {
      margin-right: 0;
    }
  }

  .paginationContainer {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    padding-bottom: 20px;
  }

  .addressListContainer {
    flex-wrap: wrap;
    margin-top: 26px;

    .activeAddressContainer {
      border: 1px solid #B4272B !important;
      background: #FCF2F2 !important;
    }

    .addressContainer, .activeAddressContainer {
      position: relative;
      width: 350px;
      height: 394px;
      background: #fff;
      border: 1px solid #DFDFDF;
      border-radius: 10px;
      padding: 10px 10px 0;
      margin-left: 26px;
      margin-bottom: 26px;

      .addressHeaderContainer {
        justify-content: space-between;
        width: 100%;

        input[type="checkbox"]:checked {
          background: #4A91E9;
          border: none;
          width: 16px;
          height: 16px;
        }

        div {
          width: 100px;
          height: 30px;
          background: #FAF2F2;
          border: 1px solid #B4272B;
          border-radius: 6px;
          line-height: 30px;
          text-align: center;
          font-size: 12px;
          color: #B4272B;
        }
      }

      .addressName {
        color: #B4272B;
        font-size: 18px;
        font-weight: bold;
        margin-left: 20px;
      }

      .addressMessageListContainer {
        margin-top: 20px;

        .addressMessageContainer {
          margin-bottom: 8px;
          margin-left: 20px;
          font-size: 14px;
          color: #000;
          text-align: left;

          div:first-child {
            width: 130px;
          }
        }
      }

      .btn {
        margin-top: 20px;
        width: 302px;
        height: 34px;
        background: #B4272B;
        border-radius: 8px;
        text-align: center;
        line-height: 34px;
        cursor: pointer;
        margin-left: 20px;
        font-size: 14px;
        color: #fff;
      }
    }
  }

  .addOrEditAddressContainer {
    /deep/ .el-dialog {
      border-radius: 10px;
      padding: 30px;
      box-sizing: border-box;

      .el-dialog__header {
        padding: 0;

        .el-dialog__title {
          font-size: 18px;
          font-weight: bold;
          color: #333;
          padding-bottom: 7px;
          border-bottom: 4px solid #B4272B;
        }

        .el-dialog__headerbtn {
          top: 30px;
          font-size: 19px;

          .el-dialog__close {
            color: #B4272b;
          }
        }
      }

      .el-dialog__body {
        padding: 0;
      }

      .el-dialog__footer {
        padding: 0;

        button {
          border-radius: 8px;
          height: 34px;
          width: 120px;
          line-height: 34px;
          padding: 0;
          font-size: 14px;
        }

        button:first-child {
          color: #B4272B;
          border: 1px solid #B4272B;
          margin-right: 26px;
        }

        .el-button + .el-button {
          margin-left: 0;
        }
      }
    }

    .checkboxContainer {
      display: flex;
      justify-content: center;
      width: 100%;
      margin: 20px 0 30px;

      /deep/ .el-checkbox {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 19px;

        .el-checkbox__inner {
          border-radius: 50%;
        }

        .el-checkbox__input {
          margin-bottom: -18px;
        }
      }
    }

    .formInput {
      /deep/ .el-input {
        width: 280px;

        .el-input__inner {
          height: 30px;
          line-height: 30px;
        }
      }

      /deep/ .el-textarea {
        width: 280px;
      }
    }
  }
}
.updateTagNameBox{
  padding: 30px 30px 20px;
  .label{
    color: #222222;
    font-size: 14px;
  }
}
</style>
